const Accordions = () => {
    let accordions = $('.accordion');

    accordions.click(e => {
        let target = $(e.currentTarget);

        target.toggleClass('accordion--open');
        target.find('.accordion__content').slideToggle(200);
    })

    $('.accordion__content').click(e => {
        e.stopPropagation();
    })
}

export default Accordions;


// WEBPACK FOOTER //
// ./src/js/app/components/Accordions.js